import { gray5 } from "assets/styleUtils";

export default function TypeText({
  title,
  content,
  action,
}: {
  title: string;
  content: string;
  action?: string;
}) {
  return (
    <div style={{ marginBottom: "8px", display: "flex" }}>
      <div style={{ width: "75px", color: gray5, lineHeight: "25px" }}>
        {title}
      </div>
      {action ? (
        <a href={action.includes("http") ? action : "https://" + action}>
          <div style={{ lineHeight: "25px" }}>{content}</div>
        </a>
      ) : (
        <div style={{ lineHeight: "25px" }}>{content}</div>
      )}
    </div>
  );
}
